export enum UserAvatarImageType {
	IMAGE = 'img',
	BACKGROUND = 'background',
}
